import {cloneDeep, findIndex} from "lodash";

export function ColorPredictionReducer(state, action) {
  switch (action.type) {
    case 'COLOR_PREDICTION_SELECT_COLOR':
      return onColorPredictionSelect(state, action.payload);
    case 'COLOR_PREDICTION_RESET':
      return onColorPredictionReset(state);
    case 'COLOR_PREDICTION_SUBMIT':
      return onColorPredictionSubmit(state, action.payload);
    //case 'PROPS_CHANGE':
      //return onColorPredictionUpdate(action.payload);
    default:
      return state;
  }
}

function onColorPredictionReset(state) {

  let widget = state.currentSection.components[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})];
  let resetWidget = {...widget, options: cloneDeep(widget.initial.options), feedbackType: '', submitted: false}

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})] = resetWidget;

  return {...state, ...{currentSection: {
    title: state.currentSection.title,
    components: currentComponents
  }}};
}

function onColorPredictionSelect(state, payload) {
  let widget = state.currentSection.components[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})];

  let options = widget.options.map((option, index) => {
    if (index === payload.optionIndex) {
      const checkboxes = option.checkboxes.map((box) => {
        if (box.value === payload.value) {
          return {...box, checked: true};
        } else {
          return {...box, checked: false};
        }
      });
      const checked = checkboxes.find((checkbox) => checkbox.checked);
      if (checked) {
        option.optionTube.solution = checked.style.backgroundColor;
      }
      return {...option, checkboxes};
    }
    return option;
  });

  widget.options = options;
  widget.feedbackType = '';
  widget.submitted = false;

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})] = widget;

  return {...state, ...{currentSection: {
    title: state.currentSection.title,
    components: currentComponents
  }}};
}

function onColorPredictionSubmit(state, payload) {

  let widget = state.currentSection.components[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})];
  let feedbackType = '';

  let hasSelectedAllOptions = widget.options.every((option) => {
    return option.checkboxes.some((box) => box.checked);
  });
  if (hasSelectedAllOptions) {
    feedbackType = 'SUCCESS';
  } else {
    feedbackType = 'FAIL';
  }

  widget.feedbackType = feedbackType;
  widget.submitted = true;

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "COLOR_PREDICTION"})] = widget;

  let data = widget.options.map((option)=>{

    let selected = option.checkboxes.find((checkbox)=>{
      return checkbox.checked === true
    });

    return {
      option: option.optionLabel,
      selected: (selected)?selected.label:null
    }
  })

  return {...state, ...{currentSection: {
    title: state.currentSection.title,
    components: currentComponents
  }}};
}
